/* Importing the React library from the node_modules folder. */
import React from 'react';
/* Importing the CheckIcon from the heroicons package. */
import { CheckIcon } from "@heroicons/react/outline";

/**
 * It returns the AllInOne component.
 * @returns AllInOne component.
 */
const AllInOne = () => {
    return (
        <section name={'platforms'} className={ 'allInOneContainer' }>
            <div className={ 'allInOneHeaderContainer' }>
                <h2>All-in-One Platform</h2>
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda, corporis dolor eius eum labore
                    molestias nemo officiis pariatur possimus voluptates.
                </p>
                <div className={ 'allInOneCards' }>

                    <div className={ 'allInOneCard' }>
                        <div>
                            <CheckIcon className={ 'allInOneCardIcon' }/>
                        </div>
                        <div>
                            <h3>Notifications</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi aperiam beatae
                                blanditiis, deleniti ipsa nam odio porro rem totam voluptate!
                            </p>
                        </div>
                    </div>

                    <div className={ 'allInOneCard' }>
                        <div>
                            <CheckIcon className={ 'allInOneCardIcon' }/>
                        </div>
                        <div>
                            <h3>Notifications</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi aperiam beatae
                                blanditiis, deleniti ipsa nam odio porro rem totam voluptate!
                            </p>
                        </div>
                    </div>

                    <div className={ 'allInOneCard' }>
                        <div>
                            <CheckIcon className={ 'allInOneCardIcon' }/>
                        </div>
                        <div>
                            <h3>Notifications</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi aperiam beatae
                                blanditiis, deleniti ipsa nam odio porro rem totam voluptate!
                            </p>
                        </div>
                    </div>

                    <div className={ 'allInOneCard' }>
                        <div>
                            <CheckIcon className={ 'allInOneCardIcon' }/>
                        </div>
                        <div>
                            <h3>Notifications</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi aperiam beatae
                                blanditiis, deleniti ipsa nam odio porro rem totam voluptate!
                            </p>
                        </div>
                    </div>

                    <div className={ 'allInOneCard' }>
                        <div>
                            <CheckIcon className={ 'allInOneCardIcon' }/>
                        </div>
                        <div>
                            <h3>Notifications</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi aperiam beatae
                                blanditiis, deleniti ipsa nam odio porro rem totam voluptate!
                            </p>
                        </div>
                    </div>

                    <div className={ 'allInOneCard' }>
                        <div>
                            <CheckIcon className={ 'allInOneCardIcon' }/>
                        </div>
                        <div>
                            <h3>Notifications</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi aperiam beatae
                                blanditiis, deleniti ipsa nam odio porro rem totam voluptate!
                            </p>
                        </div>
                    </div>

                    <div className={ 'allInOneCard' }>
                        <div>
                            <CheckIcon className={ 'allInOneCardIcon' }/>
                        </div>
                        <div>
                            <h3>Notifications</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi aperiam beatae
                                blanditiis, deleniti ipsa nam odio porro rem totam voluptate!
                            </p>
                        </div>
                    </div>

                    <div className={ 'allInOneCard' }>
                        <div>
                            <CheckIcon className={ 'allInOneCardIcon' }/>
                        </div>
                        <div>
                            <h3>Notifications</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi aperiam beatae
                                blanditiis, deleniti ipsa nam odio porro rem totam voluptate!
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};
/* Exporting the component to be used in other files. */
export default AllInOne;
